import { gql, useQuery } from '@apollo/client';

export const GET_CUTOFF_TREE = gql`
    query GetCutoffTree($hubId: Long!) {
        getCutoffTree(hubId: $hubId) {
            areaId
            name
            sortingCode
            lastCutoffAt
            planningStatus
        }
    }
`;

export type CutoffPlanningStatus = 'NOT_PROCESSED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';

export interface CutoffAreaOutput {
    areaId: number;
    name: string;
    sortingCode: string | null;
    /** epoch 毫秒；未处理为 null */
    lastCutoffAt: number | null;
    planningStatus: CutoffPlanningStatus;
}

export interface GetCutoffTreeResponse {
    getCutoffTree: CutoffAreaOutput[];
}

export interface GetCutoffTreeVariables {
    hubId: number;
}

/** 拉取当前 hub 下（已按灰度过滤的）线路及各自 cutoff 时间/状态（扁平列表，前端按 sortingCode 拆段建树） */
export const useCutoffQuery = (hubId?: number) => {
    const { data, loading, refetch } = useQuery<GetCutoffTreeResponse, GetCutoffTreeVariables>(
        GET_CUTOFF_TREE,
        {
            variables: { hubId: hubId as number },
            skip: !hubId,
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );
    return { areas: data?.getCutoffTree ?? [], loading, refetch };
};
